import { render, staticRenderFns } from "./riCoinsuranceServiceFee.vue?vue&type=template&id=412127cb&"
import script from "./riCoinsuranceServiceFee.vue?vue&type=script&lang=js&"
export * from "./riCoinsuranceServiceFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports